
import { sendLogin, usePJStore, useProfile, useUserInfo } from '@jaf/jaf-react-core';
import React, { useEffect, useRef, useState } from 'react';

import GestioneConfigurazioni from '../GestioneConfigurazioni/GestioneConfigurazioni';
import ModificaConfigurazione from '../ModificaConfigurazione/Modificaconfigurazione';
import './HomePage.css';

import { Toast } from 'primereact/toast';
import CatalogoOggetti from '../CatalogoOggetti/CatalogoOggetti';

import NuovaRichiesta from '../NuovaRichiesta/NuovaRichiesta';



function HomePage() {

  const profile = useProfile();


  const [tematica, setTematica] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);

  const [idGruppoSelezionato, setIdGruppoSelezionato] = useState(null);

  const [catalogoOggetti, setCatalogoOggetti] = useState(false);

  const getText = usePJStore((state) => state.i18n_getText)
  const toast = useRef(null);

  const params = usePJStore((state) => state.params)

  const id_gruppo_selezionato = params.id_gruppo_selezionato;

  const isLogged = useUserInfo() != null;

  useEffect(() => {
    //console.log("tematica", tematica)
  }, [JSON.stringify(tematica)]);

  useEffect(() => {

    if (!isLogged) {
      sendLogin()
    } else {
      //console.log(profile)
      if (profile.profile == 5) {

      } else {
        if (JSON.parse(sessionStorage.getItem("tematica")) != null) {
          onTematicaSelected(JSON.parse(sessionStorage.getItem("tematica")))
        }

        if (id_gruppo_selezionato != null) {
          setIdGruppoSelezionato(id_gruppo_selezionato)
        }
      }
    }





  }, []);

  const onTematicaSelected = (data) => {
    setTematica([]);

    setTimeout(() => {
      setTematica(data);
    }, 250);

  }

  const onCatalogoOggetti = () => {
    setTematica(null);
    setCatalogoOggetti(true);
  }

  const onJumpBack = () => {
    setIdGruppoSelezionato(null)
  }

  const onSave = (data, ret) => {

    /*setOfflineBundles({it: {
    
        },en:{
            
        }
    })*/
    if (ret) {
      showSuccess();
    }
    //console.log("onSave", data)
    if (data != null) {
      setTematica([]);

      setTimeout(() => {
        setTematica(data);
      }, 250);
    }
  }

  const onNodeOperation = (node) => {
    setSelectedNode(node);
  }

  const showSuccess = () => {
    toast.current.show({ severity: 'success', summary: getText("INFORMAZIONE"), detail: 'Operazione Eseguita' });
  }

  const showError = (msg) => {
    toast.current.show({ severity: 'error', summary: getText("ERRORE"), detail: msg, life: 10000 });
  }

  return (
    <>

      {profile && profile.profile == 2 &&
        <>
          <div className='Home'>
            <Toast ref={toast} position="top-right" />
            <header className='Home-header'>
              <div className='col-12'>
                {profile != null && profile.profile != 4 && tematica === null &&
                  <GestioneConfigurazioni onCatalogoOggetti={onCatalogoOggetti} onTematicaSelected={onTematicaSelected} />
                }
                {profile != null && profile.profile != 4 && tematica != null &&
                  <ModificaConfigurazione onJumpBack={onJumpBack} id_gruppo_selezionato={idGruppoSelezionato} onSuccess={showSuccess} onError={showError} onSave={onSave} onTematicaSelected={onTematicaSelected} tematica={tematica} onNodeOperation={onNodeOperation} selectedNode={selectedNode} />
                }
                {profile != null && profile.profile != 4 && catalogoOggetti &&
                  <CatalogoOggetti />
                }

                {profile != null && profile.profile == 4 &&
                  <NuovaRichiesta />
                }
              </div>
            </header>
          </div>
        </>
      }
    </>

  )
}

export default HomePage
